// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner___1iDhp","bars":"bars___1znwq"};